module.exports = __webpack_public_path__ + "img/join-us-1.d8167f6e.png";